module.exports = __webpack_public_path__ + "static/media/stop.364ee977.svg";